// extracted by mini-css-extract-plugin
export default {"mixin":"AppSetup_mixin__1oq4t","dash":"AppSetup_dash__hFzKZ"};